var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecordMic({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#363636",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.247,
    height: 18.738,
    viewBox: "0 0 13.247 18.738",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#363636",
    strokeWidth: "0.2px",
    d: "M286.688,622.657V620.18a6.448,6.448,0,0,1-6.022-6.352.5.5,0,0,1,1,0,5.521,5.521,0,0,0,11.04,0,.5.5,0,0,1,1,0,6.431,6.431,0,0,1-6.021,6.352v2.477m3.262-14.96v6.131a3.764,3.764,0,0,1-7.527,0V607.7a3.764,3.764,0,0,1,7.527,0Zm-1,0a2.761,2.761,0,0,0-5.52,0v6.131a2.761,2.761,0,0,0,5.52,0Z",
    transform: "translate(-280.567 -603.919)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordMic);
export default __webpack_public_path__ + "static/media/record-mic.25acfea1f7f6886252e98718f7f99318.svg";
export { ForwardRef as ReactComponent };